export default __webpack_public_path__ + "static/media/bfg.dd91b987.jpg";